export const getAllStudyFiles = (studyGroups = []) =>
  studyGroups.flatMap((group) => group?.files || []);

export const findStudyByName = (studyGroups = [], studyName = "") =>
  getAllStudyFiles(studyGroups).find((file) => file?.name === studyName) || null;

export const findStudyCategory = (studyGroups = [], selectedFile = null) => {
  if (!selectedFile?.name) return null;
  return (
    studyGroups.find((group) =>
      (group?.files || []).some((file) => file?.name === selectedFile.name)
    ) || null
  );
};
